import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../../../common/spinner/Spinner.jsx';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useGetPollResultsQuery } from '../../../../../redux/services/polls.jsx';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import {
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';

const PollTableResults = ({ pollId }) => {
  const { t } = useTranslation();
  const { data: pollResults, isLoading } = useGetPollResultsQuery(pollId);

  const answerTextFilter = useDataGridTextFilter('name');

  const formatPercentage = (value) => {
    return (Math.round(value * 100) / 100).toFixed(2);
  };

  const columns = (index) => {
    return [
      {
        title: t('Odpoveď'),
        dataIndex: 'name',
        ellipsis: true,
        key: 'name',
        sorter: dataGridTextSorter('name'),
        ...answerTextFilter,
      },
      {
        title: t('Počet hlasov'),
        dataIndex: 'votes',
        key: 'votes',
        sorter: dataGridNumberSorter('votes'),
        defaultSortOrder: 'descend',
      },
      {
        title: t('Percentuálny podiel hlasov'),
        dataIndex: 'votes',
        key: 'votes',
        sorter: dataGridNumberSorter('votes'),
        render: (votes) => {
          if (pollResults[index].responseCount === 0) {
            return '0.00%';
          } else {
            return (
              formatPercentage(
                (votes / pollResults[index].responseCount) * 100,
              ) + '%'
            );
          }
        },
      },
    ];
  };

  return isLoading ? (
    <Spinner />
  ) : (
    pollResults.map((question, index) => (
      <CollapseBlock
        key={'poll-res-' + index}
        title={t(question.name)}
        collapsible
      >
        <DataGrid
          key={'poll-res-' + index}
          className={'question-responses-table'}
          columns={columns(index)}
          dataSource={question.responses}
          uniqueTableId={'poll-responses-' + question.name + '-table'}
          disableSettings={true}
        />
      </CollapseBlock>
    ))
  );
};

PollTableResults.propTypes = {
  pollResults: PropTypes.any,
  pollId: PropTypes.number,
  dispatchLoad: PropTypes.func,
  dispatchUnload: PropTypes.func,
};

export default PollTableResults;
